const actions = {
	setInitTkInfo(context, payload){
		context.commit('initTkInfo') // mutation中的方法用commit回调
	}
}
export default actions;